<h2 mat-dialog-title style="padding: 30px; margin: 0">
  Visualizar PDF - Listado de Insumos
</h2>
<mat-dialog-content style="padding: 0px 30px; margin: 0" class="">
  <div
    *ngIf="loading"
    class="div-center vertical-center"
    style="height: 180px; width: 100%"
  >
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  <div
    *ngIf="!loading"
    style="width: 100%; display: flex; justify-content: center; gap: 10px"
  >
    <div
      style="
        background-color: white;
        width: 100%;
        border: solid;
        border-color: rgba(0, 0, 0, 0.12);
        border-width: 1px;
        border-radius: 10px;
        align-items: center;
        padding: 12px;
      "
    >
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div>Lista de Insumos.pdf</div>

        <div style="display: flex; justify-content: center; gap: 10px">
          <a
            (click)="activatePDF(multimedia)"
            mat-icon-button
            class="row-base center-div icon-Active"
          >
            <i-tabler name="eye"></i-tabler>
          </a>
        </div>
      </div>

      <div style="display: flex; justify-content: center" *ngIf="pdfViewer">
        <iframe [src]="multimedia" width="600" height="400"> </iframe>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions
  class="row-base"
  style="justify-content: flex-end; padding: 30px; margin: 0; min-height: auto"
>
  <!-- <div>hola</div> -->
  <button
    mat-flat-button
    style="
      border: 1px solid #e95a1a;
      border-radius: 4px;
      color: #e95a1a;
      width: 128px;
      text-align: center;
    "
    (click)="onCancel()"
  >
    Cerrar
  </button>
</mat-dialog-actions>
